import { File } from "./File";
import { Matter } from "./Matter";
import { Participant } from "./Participant";
import { User } from "./User";

export const financialItemTypes = [
  { title: "Real Estate", id: "real_estate", description: "", order: 0 },
  {
    title: "Household Items",
    id: "household_items",
    description: "",
    order: 1,
  },
  {
    title: "Jewelry, Antiques, Art",
    id: "jewelry_antiques_art",
    description: "",
    order: 2,
  },
  {
    title: "Vehicles, Boats, Trailers",
    id: "vehicles_boats_trailers",
    description: "",
    order: 3,
  },
  {
    title: "Savings Account",
    id: "savings_account",
    description: "",
    order: 4,
  },
  {
    title: "Checking Account",
    id: "checking_account",
    description: "",
    order: 5,
  },
  {
    title: "Credit Union Account",
    id: "credit_union_account",
    description: "",
    order: 6,
  },
  { title: "Cash", id: "cash", description: "", order: 7 },
  { title: "Tax Refund", id: "tax_refund", description: "", order: 8 },
  {
    title: "Life Insurance with Cash Value",
    id: "life_insurance_cash_value",
    description: "",
    order: 9,
  },
  {
    title: "Securities, Stocks, Bonds",
    id: "securities_stocks_bonds",
    description: "",
    order: 10,
  },
  {
    title: "Retirement and Pension",
    id: "retirement_pension",
    description: "",
    order: 11,
  },
  {
    title: "Annuities, IRAs, Deferred Compensation",
    id: "annuities_iras_deferred_comp",
    description: "",
    order: 12,
  },
  {
    title: "Accounts Receivable and Notes",
    id: "accounts_receivable_notes",
    description: "",
    order: 13,
  },
  {
    title: "Business Interest",
    id: "business_interest",
    description: "",
    order: 14,
  },
  { title: "Other Asset", id: "other_asset", description: "", order: 15 },
  { title: "Student Loan", id: "student_loan", description: "", order: 16 },
  { title: "Taxes Due", id: "taxes_due", description: "", order: 17 },
  {
    title: "Support Arrearage",
    id: "support_arrearage",
    description: "",
    order: 18,
  },
  { title: "Unsecured Loan", id: "unsecured_loan", description: "", order: 19 },
  {
    title: "Credit Card Debt",
    id: "credit_card_debt",
    description: "",
    order: 20,
  },
  { title: "Other Debt", id: "other_debt", description: "", order: 21 },
];
export type FinancialItemTypeData = (typeof financialItemTypes)[number];
export type FinancialItemType = (typeof financialItemTypes)[number]["id"];

export interface FinancialItem {
  _id: string;
  matter: Matter["_id"] | Matter;
  participant?: Participant["_id"] | Participant;
  type: FinancialItemType;
  category: "asset" | "debt";
  name: string;
  description?: string;
  amount: number;
  associatedDebtAmount: number;
  currency: string;
  dateValued?: Date;
  dateAcquired?: Date;
  ownershipStatus: "separate" | "marital";
  ownershipPercentage: number;
  files: File["_id"][];

  createdAt: Date;
  createdBy: User["_id"];
  updatedAt: Date;
  updatedBy?: User["_id"];
}
